// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ukrN","colBig":"styles_colBig__VBDjU","colSmall":"styles_colSmall__fr8hu"};